import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { enqueueControlSlideLatestWins } from '@/state/mutations/player/control-slide-latest-wins.helper';

interface ControlSlideParams {
  mediaId: string;
  entityType: string;
  entityId: string;
  action: 'next' | 'prev' | 'first' | 'last' | 'goto';
  slideNumber?: number;
}

interface ControlSlideResponse {
  success: boolean;
}

export const useControlSlideMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (params: ControlSlideParams): Promise<ControlSlideResponse> => {
      const token = await getToken();
      return enqueueControlSlideLatestWins(params, (next) => controlSlide(next, token ?? ''));
    },
  });
};

const controlSlide = async (body: ControlSlideParams, token: string): Promise<ControlSlideResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/player/control-slide`;
  return await sendJSONRequest({ url, method: METHOD.POST, body, token });
};
